import api from '../../../api';
import { ResponseSuccess } from '../../../shared/types';

export const getMcpSessions = async () =>
  api.get<ResponseSuccess>('/auth/mcp/sessions');

export const revokeMcpSession = async (sessionId: number) =>
  api.delete<ResponseSuccess>(`/auth/mcp/sessions/${sessionId}`);
